<template>
  <ul class="simple-filters">
    <li v-for="(item, index) in items" :key="index" @click="toggleSelect(item)">
      <slot
        name="item"
        :item="{ ...item, disabled: selected && selected != item.id }"
      >
        <span class="item-content" :class="{ disabled: item.disabled }">{{
          item.name
        }}</span>
      </slot>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [
        { id: 1, color: 'blue', name: 'element 1', value: 1 },
        { id: 2, color: 'green', name: 'element 2', value: 2 },
        { id: 3, color: 'yellow', name: 'element 3', value: 3 }
      ]
    }
  },
  data() {
    return {
      selected: null
    }
  },
  methods: {
    reset() {
      this.selected = null
      this.$emit('filter', null)
    },
    toggleSelect(item) {
      this.selected = item.id === this.selected ? null : item.id
      this.$emit('filter', this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  li {
    cursor: pointer;
  }
}
.disabled {
  opacity: 0.3;
}
.highlighted {
  font-weight: 800;
}
</style>
